import { render, staticRenderFns } from "./RefinementResults.vue?vue&type=template&id=bbb4e2b8&scoped=true&"
import script from "./RefinementResults.vue?vue&type=script&lang=js&"
export * from "./RefinementResults.vue?vue&type=script&lang=js&"
import style0 from "./RefinementResults.vue?vue&type=style&index=0&id=bbb4e2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb4e2b8",
  null
  
)

export default component.exports